export const valueHandler = value => {
  if (value < 0) return 0;
  if (value > 1) return 100;
  return Math.round(value * 100);
};

export const handleColorSelection = (value, rules) => {
  if (value >= rules.success.bottom && value <= rules.success.top)
    return 'success';
  if (value >= rules.warning.bottom && value <= rules.warning.top)
    return 'warning';
  return 'error';
};
